import i18n from '@/translation/i18n';
import familyForm from '@/constants/familyForm';

export default function () {
    const langs = i18n.t('validation');
    const dictionary = {};
    const separator = '__';

    for (const key in langs) {
        let type = {};
        const indexOfSeparator = key.indexOf(separator);
        const fieldProperty = key.slice(0, indexOfSeparator);
        const dictionaryProperty = key.slice(indexOfSeparator + separator.length);

        if (dictionary[dictionaryProperty] !== undefined) {
            type = dictionary[dictionaryProperty];
        }

        type[fieldProperty] = langs[key];

        if (dictionaryProperty === 'phone') {
            for (let i = 0; i < familyForm.MAX_PHONE_INPUT_FIELD; i++) {
                dictionary[dictionaryProperty + i] = type;
            }
        }

        dictionary[dictionaryProperty] = type;
    }
    return dictionary;
}
